import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'table-main-section',
  template: `
    <!--todo this component could be refactor it is the same as facilities and services-->
    <div (click)="toggleSection()">
      <section-row
        [isMobile] = "isMobile"
        [columnHeader] = "columnHeader"
        [sectionRowLabel] = "sectionRowLabel"
        [sectionRowData]  = "sectionRowData"
        [sectionRowOpen]  = "sectionRowOpen">
      </section-row>
    </div>
    
    <div *ngIf="sectionRowOpen">
      <div *ngFor="let rowData of subSectionRows" >
        <subsection-row
          [isMobile] = "isMobile"
          [columnHeader] = "columnHeader"
          [rowData]="rowData"
          [sectionRowOpen]="sectionRowOpen">
        </subsection-row>
      </div>
    </div>
  `
})
export class TableMainSectionComponent implements OnInit {
  @Input() mainSectionData;
  @Input() isMobile;
  @Input() columnHeader;
  subSectionRows;
  sectionRowData;
  sectionRowLabel;
  sectionRowOpen = true;
  currentTableSectionState;

  constructor(private store: Store<any>) {
    store.select('currentUser').subscribe(currentUser => {
      this.currentTableSectionState = currentUser;
      this.setLetsOpen(currentUser);
    });
  }

  ngOnInit() {
    this.getSectionRowLabel();
    this.getSectionRow();
    this.getSubSectionRows();
  }

  setLetsOpen(currentUser) {
    this.sectionRowOpen = currentUser.allSectionsOpen;
  }

  getSubSectionRows() {
    this.subSectionRows = this.mainSectionData.subsections;
  }

  getSectionRowLabel() {
    this.sectionRowLabel = this.mainSectionData.label;
  }

  getSectionRow() {
    this.sectionRowData = this.mainSectionData.row;
  }

  toggleSection() {
    this.sectionRowOpen = !this.sectionRowOpen;
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/table-main-section/table-main-section.component.ts